// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2DzIA","loaderOuter":"PageOverlayLoader_loaderOuter__1DwX_"};